export default class HeaderSticky {
	constructor(name, element) {
		this.name = name;
		this.master = element;
		const defaultOpts = {
			stickyClass: 'js-sticky',
			showFrom: 0,
			loadClass: 'js-loading',
		};
		const parsedOpts = this._hasOpts() ? this._getParsedOpts() : {};
		this.opts = {...defaultOpts, ...parsedOpts}
	}

	_setOffset() {
		const showFrom = this.opts.showFrom;
		this.opts.showFrom = showFrom === 'full' ? window.innerHeight : showFrom;
	}

	_bindWindowEvents() {
		window.addEventListener('scroll', this.toggleHeader.bind(this));
		window.addEventListener('load', this._onload.bind(this));
	}

	_hasOpts() {
		return !!this.master.dataset.opts
	}

	_getParsedOpts() {
		return JSON.parse(this.master.dataset.opts)
	}

	_onload() {
		this.toggleHeader();
		this.loadHeader();
	}

	start() {
		this._setOffset();
		this._bindWindowEvents();
		this.toggleHeader();
	}

	loadHeader() {
		this.master.classList.remove(this.opts.loadClass);
	}

	toggleHeader() {
		(window.pageYOffset > this.opts.showFrom)
			? this.master.classList.add(this.opts.stickyClass)
			: this.master.classList.remove(this.opts.stickyClass);
	}
}
